var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 345,
    height: 344,
    viewBox: "0 0 345 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_248_956",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 345,
    height: 345
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.355469 -0.00732422H344.355V343.987H0.355469V-0.00732422Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_248_956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.4648 110.675L0.355469 171.784L61.4648 233.3V110.675ZM283.246 233.3L344.355 171.784L283.246 110.675V233.3ZM233.871 61.3001L172.355 0.190674L111.246 61.3001H233.871ZM111.246 282.675L172.355 343.784L233.871 282.675H111.246ZM105.986 114.722H239.132V151.55H105.986V114.722ZM105.986 190.805H239.132V229.253H105.986V190.805Z",
    fill: "#F0573E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10);
export default __webpack_public_path__ + "static/media/10.01e33b4a1797dcdf89e3df00bfe5e4bd.svg";
export { ForwardRef as ReactComponent };